import React, { useRef, useEffect } from 'react'
import { CountUp as Count } from 'countup.js'

const CountUp =
React.memo(({ value, startVal = value * 0.95, duration = 3, ...props }) => {
  const countUp = useRef()
  const element = useRef()

  useEffect(() => {
    if (countUp.current)
      countUp.current.update(value)
    else {
      countUp.current = new Count(element.current, value,
        { ...props, startVal, duration })
      countUp.current.start()
    }
  }, [ value ])

  return (
    <span ref={element}>
      {new Count(null, null, props).formatNumber(startVal)}
    </span>
  )
})

export default CountUp
